import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SearchListingFilterPageComponent } from './search-listing-filter-page.component';
import { SearchListingFilterPageRoutingModule } from './search-listing-filter-page-routing.module';
import { SharedModule } from '../@shared/shared.module';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedExceptMainModule } from '../@shared-except-main/shared-except-main.module';

@NgModule({
    declarations: [SearchListingFilterPageComponent],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        SearchListingFilterPageRoutingModule,
        SharedExceptMainModule,
        SharedModule,
        MatTabsModule,
    ],
    exports: [SearchListingFilterPageComponent],
})
export class SearchListingFilterPageModule {}
